export const userService = {
    registration,
    login,
    getUser,
    logout
};

function login(data) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
        credentials: 'include'
    };

    return fetch(`${process.env.VUE_APP_API_URL}/api/login`, requestOptions)
        .then(handleResponse)
        .then(result => {
            localStorage.setItem('user', JSON.stringify(result.user));
            return result.user;
        });
}

async function getUser() {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include'
    };

    return await fetch(`${process.env.VUE_APP_API_URL}/api/user`, requestOptions)
        .then(handleResponse)
        .then(result => {
            localStorage.setItem('user', JSON.stringify(result.user));
            return result.user;
        });
}

function registration(data) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    };

    return fetch(`${process.env.VUE_APP_API_URL}/api/registration`, requestOptions)
        .then(handleResponse);
}

function logout() {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include'
    };

    return fetch(`${process.env.VUE_APP_API_URL}/api/logout`, requestOptions)
        .then(handleResponse)
        .then(() => {
            localStorage.removeItem('user')
        });
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            const error = (data && data.error) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}